import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as messageService from "../../services/messageService";
import { handleApiError } from "../storeEffects";
import { MessageAction, messageFailure, messageSuccess } from "./storeMessage";

export type MessageThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, MessageAction>

export const getMessagePage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return messageService.getMessagePage()
        .then(
            messagePage => {
                dispatch(messageSuccess(messagePage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(messageFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};